require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-paris-motor-show-2018-week-1-round-up.json") })
        }
      }, "path---authors-paris-motor-show-2018-week-1-round-up");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-paris-motor-show-2018-week-1-round-up!./.cache/json/authors-paris-motor-show-2018-week-1-round-up.json
// module id = 1321
// module chunks = 231608221292675